import { apiClient } from "~/services/apiClient";
import type { AuthUser } from "~/types/auth";

export async function getProfile() {
  const response = await apiClient.get<AuthUser>("/api/profile");
  return response.data;
}

export async function updateProfile(payload: {
  name: string;
  surname?: string;
  status?: "PENDING" | "ACTIVE" | "INACTIVE";
}) {
  const response = await apiClient.put<AuthUser>("/api/profile", payload);
  return response.data;
}

export async function changePassword(payload: {
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
}) {
  const response = await apiClient.put<{ message: string }>(
    "/api/profile/password",
    payload
  );
  return response.data;
}

export type ProfilePresignedUpload = {
  url: string;
  key: string;
  expiresIn?: number;
  requiredHeaders?: Record<string, string>;
};

export async function getProfileUploadUrl(payload: {
  fileName: string;
  fileSize: number;
  contentType: string;
}) {
  const response = await apiClient.post<ProfilePresignedUpload>(
    "/api/profile/profile-picture/presigned-url",
    payload
  );
  return response.data;
}

export async function completeProfileUpload(key: string) {
  const response = await apiClient.post<AuthUser>(
    "/api/profile/profile-picture/complete",
    { key }
  );
  return response.data;
}
